import { makeAutoObservable } from "mobx";
import { PPrice } from "./PPrice";
export class PProductInstanceVariant {
    constructor(params) {
        this.instance = params.instance;
        this.productInstancePriceService = params.productInstancePriceService;
        this.purchaseOrderPayload = params.purchaseOrderPayload;
        this.variantParameterChoiceName = params.variantParameterChoiceName;
        this.localizationProvider = params.localizationProvider;
        makeAutoObservable(this);
    }
    get isAvailable() {
        return true;
    }
    get inCartQuantity() {
        return this.purchaseOrderPayload.cartCount(this.instance).value;
    }
    get price() {
        return new PPrice(this.localizationProvider, this.productInstancePriceService.price(this.instance).spectrum);
    }
    get fieldId() {
        const productIds = this.instance.productTypeIds.rawValues();
        const choiceIds = this.instance.customParameters.choiceIds.rawValues();
        if (choiceIds.length > 0) {
            // TODO: think about the format for field-id's like this one (with choices)
            return `${productIds.join(".")}.choices.${choiceIds.join(".")}`;
        }
        else {
            return `${productIds.join(".")}`;
        }
    }
}
